module.exports = __webpack_public_path__ + "static/media/Ezugi.c211072f.webp";